import styled from 'styled-components'
import {
  colours
} from 'styles/global.styles'

export const Container = styled.div`
    background-color: ${colours.darker_alpha90};
`